import React from "react";
import { Box, Grid, Skeleton, Typography } from "@mui/material";

import OrderDriverAutocomplete from "../OrderDriverAutocomplete";
import { DriverSelectOption } from "../OrderDriverAutocomplete/buildDriverSelectOptions";
import * as Styled from "./styles";

const SKELETON_BOX_SX = {
  width: "55%",
  minWidth: 200,
  maxWidth: 315,
} as const;

interface DriverEditViewProps {
  loading: boolean;
  options: DriverSelectOption[];
  value: DriverSelectOption | null;
  showDriverInsight: boolean;
  onChange: (option: DriverSelectOption | null) => void;
  onCancel: () => void;
  onApply: () => void;
}

function DriverEditView({
  loading,
  options,
  value,
  onChange,
  onCancel,
  onApply,
  showDriverInsight,
}: DriverEditViewProps) {
  const autocompleteProps = {
    options,
    value,
    onChange,
    loading: false as const,
    showDriverInsight,
  };

  return (
    <Styled.ContainerDriver>
      <Styled.ContainerAutoComplete>
        {loading ? (
          <Box sx={SKELETON_BOX_SX}>
            <Skeleton
              variant="rounded"
              animation="wave"
              height={12}
              width="72%"
              sx={{ mb: 1, borderRadius: "4px" }}
            />
            <Skeleton
              variant="rounded"
              animation="wave"
              height={35}
              sx={{ borderRadius: "8px" }}
            />
          </Box>
        ) : (
          <OrderDriverAutocomplete {...autocompleteProps} />
        )}
        <Grid>
          <Styled.ContainerButtonsDrive>
            <Styled.ButtonBackDrive type="button" onClick={onCancel}>
              <Typography variant="button" textAlign="start">
                Sair
              </Typography>
            </Styled.ButtonBackDrive>
            <Styled.ButtonApplyDrive
              type="button"
              disabled={loading || !value}
              onClick={onApply}
            >
              <Typography variant="button" textAlign="start">
                Aplicar
              </Typography>
            </Styled.ButtonApplyDrive>
          </Styled.ContainerButtonsDrive>
        </Grid>
      </Styled.ContainerAutoComplete>
    </Styled.ContainerDriver>
  );
}

export default DriverEditView;
